import * as React from 'react';

import PopoutMenu, { PopoutMenuItem } from '../../PopoutMenu';

interface Props {
    isActive: boolean;
    items: Array<React.ReactNode>;
    activeTabKey: string | null;
    onExtraMenuClick: (evt: React.MouseEvent) => void;
    onItemClick: (tkey: string) => void;
    className: string;
}

export default class TabListExtraMenu extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    isReactElementLike = (component: React.ReactNode): component is React.ReactElement => {
        return !!component && typeof component === 'object' && (component as React.ReactElement).type !== 'undefined';
    };

    renderExtraMenu(): React.ReactNode {
        const { isActive, items, activeTabKey, onItemClick } = this.props;

        return (
            <PopoutMenu active={isActive} anchor="right">
                {items.map((item): React.ReactNode => {
                    if (!this.isReactElementLike(item)) {
                        return null;
                    }

                    const { tkey, label } = item.props;

                    return (
                        <PopoutMenuItem
                            key={tkey}
                            menukey={tkey}
                            active={tkey === activeTabKey}
                            onClick={onItemClick.bind(this, tkey)}
                        >
                            {label}
                        </PopoutMenuItem>
                    );
                })}
            </PopoutMenu>
        );
    }

    render() {
        const { isActive, items, activeTabKey, onExtraMenuClick, className } = this.props;

        if (!items.length) {
            return null;
        }

        let classNames: Array<string> = ['ddbc-tab-list__nav-item', className];
        let activeSubTab = items.find((item) => {
            if (this.isReactElementLike(item)) {
                return item.props.tkey === activeTabKey;
            }

            return false;
        });

        if (isActive || activeSubTab) {
            classNames = [...classNames, 'ddbc-tab-list__nav-item--is-active'];
        }

        return (
            <div className={classNames.join(' ')} onClick={onExtraMenuClick}>
                <span className="ddbc-tab-list__nav-item-label">More</span>
                {this.renderExtraMenu()}
            </div>
        );
    }
}
